import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface Props {
  article: Article;
}

export default function ArticleHeader({ article }: Props) {
  return (
    <section className="relative w-full pt-16 md:pt-18">
      <div className="w-full px-4 md:px-10 py-8 md:py-14">
        <nav className="mb-6" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-xs flex-wrap">
            <li>
              <Link to="/" className="text-foreground-400 hover:text-foreground-700 whitespace-nowrap cursor-pointer transition-colors duration-200">
                首页
              </Link>
            </li>
            <li>
              <span className="text-foreground-300">/</span>
            </li>
            <li>
              <Link to={`/category/${article.category}`} className="text-foreground-400 hover:text-foreground-700 whitespace-nowrap cursor-pointer transition-colors duration-200">
                {article.categoryName}
              </Link>
            </li>
            <li>
              <span className="text-foreground-300">/</span>
            </li>
            <li>
              <span className="text-accent-600 font-medium">正文</span>
            </li>
          </ol>
        </nav>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[40%] flex flex-col justify-center">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              {article.title}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {article.excerpt}
            </p>
            <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-400">
              <div className="flex items-center gap-1.5">
                <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                <span>{article.author}</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                <span>{article.publishDate}</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>
                <span>
                  {article.readCount >= 10000
                    ? `${(article.readCount / 10000).toFixed(1)}万`
                    : article.readCount}{" "}
                  阅读
                </span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>
                <span>
                  {article.commentCount >= 10000
                    ? `${(article.commentCount / 10000).toFixed(1)}万`
                    : article.commentCount}{" "}
                  评论
                </span>
              </div>
            </div>
            {article.tags.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-4">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="lg:w-[60%]">
            <div className="rounded-2xl overflow-hidden h-48 md:h-80">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}